<template>
    <div :class="{ show: route.showSidebar }" class="route-panel-wrapper">
        <div class="row no-pad" style="height: 100%;">
            <!--<button @click="toggleSideBar()" class="btn btn-primary btn-block">
                Schliessen
            </button>-->
            <div id="route-container"  class="col-sm-12"></div>
        </div>
    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  export default {
    components: {
    },
    props: {
    },
    data() {
      return {
      }
    },
    mounted () {
    },
    methods: {
      ...mapActions([
        'hideStationDetail',
        'setMapOptions',
        'clearRouteStore'
      ]),
      toggleSideBar () {
        this.$store.commit('TOGGLE_SIDEBAR')
      }
    },
    computed: {
      ...mapGetters({
        mapOptions: 'mapOptions',
        route: 'route'
      })
    },
    filters: {

    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// routePanel.vue?150d8194